<template>
  <div class="search" v-if="visible">
    <div class="search-close">
      <div class="close" @click="close"></div>
    </div>
    <div class="search-body">
      <div class="input">
        <div class="icon-search"></div>
        <input type="text" id="search" placeholder="请输入您寻找的内容" />
        <button class="click-search" @click="clickSearch()"></button>
      </div>
    </div>
    <!-- 联想页 -->
    <div class="search-more" v-if="initSearch">
      <div class="f18fff18">
        <span>热门关键词：</span>
        <span style="opacity: 0.6" @click="close()">
          <router-link to="/aboutus"> 关于亿斯阁 </router-link>
        </span>
        <span style="opacity: 0.6" @click="close()">
          <router-link to="/service#s1"> 全球身份规划 </router-link>
        </span>
        <span style="opacity: 0.6" @click="close()">
          <router-link to="/service#s2"> 财富管理 </router-link>
        </span>
      </div>
      <div class="top">
        <div class="left">
          <div class="f241E2">您可能在寻找</div>
          <div class="nav">
            <div class="f181E218">
              <div>关于亿斯阁</div>
              <div @click="close()">
                <router-link to="/aboutus#s1"> 品牌故事 </router-link>
              </div>
              <div @click="close()">
                <router-link to="/aboutus#s2"> 使命 </router-link>
              </div>
              <div @click="close()">
                <router-link to="/aboutus#s2"> 愿景 </router-link>
              </div>
              <div @click="close()">
                <router-link to="/aboutus#s3"> 服务理念与承诺 </router-link>
              </div>
              <div @click="close()">
                <router-link to="/aboutus#s4"> 全球网络 </router-link>
              </div>
            </div>
            <div class="f181E218">
              <div>业务服务</div>
              <div @click="close()">
                <router-link to="/service#s1"> 全球身份规划服务 </router-link>
              </div>
              <div @click="close()">
                <router-link to="/service#s1"> 财富管理与资产保护 </router-link>
              </div>
              <div @click="close()">
                <router-link to="/service#s1"> 高端生活方式服务 </router-link>
              </div>
            </div>
            <div class="f181E218">
              <div>资源中心</div>
              <div @click="close()">
                <router-link to="/news">亿斯阁动态</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="f241E2">关注亿斯阁</div>
          <div>
            <img src="@/assets/pc/icon-contact1.png" alt="" />
            <img src="@/assets/pc/icon-contact2.png" alt="" />
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="f18fff18">
          <div>欢迎随时与我们联系</div>
          <div class="f241E2" style="color: #fff">
            邮箱：info@futurecitizen.group
          </div>
        </div>
        <button @click="close()">
          <router-link to="/contact">立即咨询</router-link>
        </button>
      </div>
    </div>
    <!-- 搜索列表页 -->
    <div class="search-list" v-if="resultSearch">
      <div class="f181E218" style="opacity: 0.6">
        已为您找到 "{{ this.searchKey }}" 的以下内容
      </div>
      <template v-for="item in resultList">
        <div class="search-listitem f181E218">
          <div style="opacity: 0.7">{{ item.pageName }}</div>
          <div class="text">
            {{ item.content }}
          </div>
          <div @click="close();" style="color: #ba9153">
            <router-link :to="`${item.link}`">{{ $t("LearnMore") }}</router-link>
          </div>
        </div>
      </template>
    </div>
    <!-- 缺省页 -->
    <div class="search-nomore" v-if="resultNone">
      <img src="@/assets/pc/nomore.gif" alt="" />
      <div class="f241E2">未找到搜索内容</div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import {SearchKey} from "@/api/api";
export default {
  data() {
    return {
      initSearch:true,
      resultSearch:false,
      resultNone:false,
      searchKey:null,
      resultList:[]
    };
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    resultNone(newValue) {
      if (newValue) {
        // 三秒后隐藏蒙层
        setTimeout(() => {
          this.resultNone = false;
          this.initSearch = true;
        }, 3000);
      }
    },
  },
  methods: {
    close() {
      this.initSearch = true;
      this.resultSearch = false;
      this.$emit("update:visible", false);
    },
    clickSearch(){
      const _searchKey = $.trim($("#search").val());
      if (_searchKey !== '' && _searchKey !== undefined){
        this.searchKey = _searchKey;
        SearchKey(_searchKey).then((res)=>{
          this.initSearch = false;
          if (res.data.code == 1){
            this.resultList = res.data.data;
            this.resultSearch = true;
          }else{
            this.resultNone = true;
          }
        });
      }
    }
  },
};
</script>
<style scoped>
.search-nomore {
  /* background: #ba9153; */
  height: auto;
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.search-nomore img {
  padding-top: 7%;
  object-fit: cover;
  width: 200px;
  height: 200px;
}
.search {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  padding: 7% 8.33vw 7% 8.33vw;
  overflow: scroll;
}
.search .search-close {
  width: 100%;
  display: flex;
  justify-content: end;
}
.search .search-close .close {
  background: url(@/assets/pc/icon-close.png) no-repeat;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.input {
  width: 100%;
  height: 84px;
  background: #f7f7f8;
  border-radius: 8px 8px 8px 8px;
  display: flex;
  align-items: center;
  padding: 0 40px;
  margin: 40px 0;
  position: relative;
}
.input .click-search{
  position: absolute;
  width: 92px;
  height: 52px;
  border-radius: 2px 2px 2px 2px;
  background: #BA9153 url(@/assets/click-search.png) no-repeat center;
  background-size: 32px;
  right: 40px;
  border: none;
  cursor: pointer;
}
.input .icon-search {
  background: url(@/assets/pc/icon-search2.png) no-repeat;
  width: 32px;
  height: 32px;
  margin-right: 18px;
}
.input input {
  width: 100%;
  height: 32px;
  border: none;
  background: none;
  font-size: 18px;
  color: #666666;
}
.input input:focus {
  outline: none;
  /* background: rgba(3, 16, 28, 0); */
}
.search .search-more > .f18fff18 {
  padding-bottom: 40px;
  border-bottom: #e4e4e4 solid 1px;
}
.search .search-more > .f18fff18 > span {
  color: #1e2344 !important;
  padding-right: 20px;
}
.search-more .top {
  display: flex;
  justify-content: space-between;
  padding: 40px 0 40px 0;
}
.search-more .top .left .f241E2 {
  padding-bottom: 20px;
}
.search-more .top .left .nav {
  display: flex;
}
.search-more .top .left .nav .f181E218 {
  padding-right: 80px;
}
.search-more .top .left .nav .f181E218 > div:first-of-type {
  opacity: 1;
}
.search-more .top .left .nav .f181E218 > * {
  padding-top: 20px;
  opacity: 0.6;
}
.search-more .top .right {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.search-more .top .right img:first-of-type {
  margin-right: 40px;
  margin-top: 40px;
}
.search-more .bottom {
  width: 100%;
  height: 142px;
  background: url(@/assets/pc/contact-banner.jpg) no-repeat;
  background-size: cover;
  padding: 40px;
  display: flex;
  justify-content: space-between;
}
.search-more .bottom .f18fff18 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.search-more .bottom button {
  width: 121px;
  height: 44px;
  padding: 10px;
  background: #ba9153;
  border: none;
  font-size: 24px;
  color: #ffffff;
  line-height: 24px;
  letter-spacing: 1px;
}
.search-list .search-listitem {
  padding: 40px;
  box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.05);
  background: #ffffff;
  margin-bottom: 40px;
  cursor: pointer;
}
.search-list .search-listitem:hover {
  background: rgba(255, 246, 230, 0.6);
}
.search-list .search-listitem:last-of-type {
  margin-bottom: 0px;
}
.search-list .search-listitem > .text {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.search-list .search-listitem > * {
  padding-top: 20px;
}
.search-list .search-listitem > div:first-of-type {
  padding-top: 0px;
}
.search-list > .f181E218 {
  padding-bottom: 40px;
}
</style>
